// extracted by mini-css-extract-plugin
module.exports = {"content":"arch-module--content--LjR6m","container":"arch-module--container--3eIHL","archImage":"arch-module--archImage--1xLNY"};